import axios from "axios";
import { AuthHelper } from "./AuthHelper";

class ApiHelperWrapper {
    requests = {};

    getAxiosHeaders() {
        return {
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
            },
        };
    }

    async cancelRequest(requestId, options) {
        if (!this.requests[requestId]) {
            return null;
        }

        if (options.ignoreFirstCancelInStrict) {
            // @ToDo: Prüfen ob im Strict-Mode
            if (this.requests[requestId].cancelCounts === 0) {
                this.requests[requestId].cancelCounts++;
                return;
            }
        }

        this.requests[requestId].cancelController.cancel("Operation canceled by the system.");
        delete this.requests[requestId];
    }

    request(path, data, method, config) {
        if (!config) {
            config = {};
        }

        if (!data) {
            data = {};
        }

        if (this._env) {
            data._env = this._env;
        }

        const token = AuthHelper.getToken();
        if (token && token.trim() !== "") {
            config["headers"] = { Authorization: `Bearer ${token}` };
        }

        if (config && config.requestId) {
            this.requests[config.requestId] = {
                cancelController: axios.CancelToken.source(),
                cancelCounts: 0,
            };
        }

        return new Promise((resolve, reject) => {
            if (config && config.responseType && config.responseType === "blob") {
                if (this._env) {
                    if (path.indexOf("?") > 0) {
                        path += "&_env=" + this._env;
                    } else {
                        path += "?_env=" + this._env;
                    }
                }

                axios({
                    url: config.raw ? path : this.buildApiPath(path),
                    method: method ? method : "GET",
                    responseType: "blob",
                    data: data,
                    headers: config.headers,
                    cancelToken:
                        this.requests[config.requestId] && this.requests[config.requestId].cancelController
                            ? this.requests[config.requestId].cancelController.token
                            : null, //config.cancelToken ? config.cancelToken : null,
                    //signal: config.signal ? config.signal : null,
                })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            } else {
                const request =
                    method === "GET"
                        ? axios.get(config.raw ? path : this.buildApiPath(path), data, {
                              ...config,
                              cancelToken:
                                  this.requests[config.requestId] && this.requests[config.requestId].cancelController
                                      ? this.requests[config.requestId].cancelController.token
                                      : null,
                          })
                        : axios.post(config.raw ? path : this.buildApiPath(path), data, {
                              ...config,
                              cancelToken:
                                  this.requests[config.requestId] && this.requests[config.requestId].cancelController
                                      ? this.requests[config.requestId].cancelController.token
                                      : null,
                          });
                request
                    .then((response) => {
                        resolve(response.data, response);
                    })
                    .catch((error) => {
                        reject(error.response && error.response ? error.response : null);
                    });
            }
        });
    }

    uploadFile(path, file, params, method, config) {
        if (!config) {
            config = {};
        }

        const token = AuthHelper.getToken();
        if (token && token.trim() !== "") {
            config["headers"] = {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            };
        }

        const formData = new FormData();
        formData.append("file", file);

        if (params) {
            for (let i in params) {
                formData.append(i, params[i]);
            }
        }

        return new Promise((resolve, reject) => {
            axios({
                url: config.raw ? path : this.buildApiPath(path),
                method: method ? method : "POST",
                data: formData,
                headers: config.headers,
            })
                .then((response) => {
                    resolve(response.data, response);
                })
                .catch((error) => {
                    reject(error.response ? error.response : null);
                });
        });
    }

    buildApiPath(path) {
        path = path.trim();
        if (path.substring(0, 1) === "/") {
            path = path.substring(1);
        }
        return process.env.REACT_APP_API_URL + path;
    }
}

const ApiHelper = new ApiHelperWrapper();
export { ApiHelper };
